// Roadmap 1b.9 (A2-305) — "Download LIPE file" for the Italian return.
//
// The file is the Agenzia delle Entrate's LIPE supply (Fornitura IVP18), to
// upload and sign through Entratel or Fisconline — not a submission. Until
// now the server could build it but no screen offered it, and the file it
// built failed the Agenzia's own schema. Same shape as the Swedish button:
// the reason it is unavailable is said up front.
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { downloadItLipeXml } from "../../lib/api";

export const ItXmlDownload = ({ calcId, frozen, readyToFile }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const blockedReason = !frozen
    ? t("ui.it_xml.blocked_frozen")
    : !readyToFile
      ? t("ui.it_xml.blocked_checks")
      : null;

  const onClick = async () => {
    setBusy(true);
    setError(null);
    const res = await downloadItLipeXml(calcId);
    setBusy(false);
    if (!res.ok) setError(res.error || t("ui.it_xml.failed"));
  };

  return (
    <div data-testid="it-xml-download" className="mt-3 flex flex-col gap-1">
      <div className="flex items-center gap-3">
        <button
          type="button"
          data-testid="it-xml-download-btn"
          onClick={onClick}
          disabled={!!blockedReason || busy}
          aria-describedby="it-xml-download-note"
          className="rounded-lg border border-teal-600 dark:border-teal-500 px-3 py-1.5 text-sm font-medium text-teal-700 dark:text-teal-300 hover:bg-teal-50 dark:hover:bg-teal-900/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {busy ? t("ui.it_xml.preparing") : t("ui.it_xml.button")}
        </button>
        <span id="it-xml-download-note" className="text-xs text-slate-500 dark:text-slate-400">
          {blockedReason || t("ui.it_xml.note")}
        </span>
      </div>
      {error && (
        <div role="alert" data-testid="it-xml-download-error" className="text-xs text-rose-700 dark:text-rose-300">
          {error}
        </div>
      )}
    </div>
  );
};
